import {
  join,
  lensIndex,
  map,
  over,
  pipe,
  replace,
  split,
  toLower,
  trim,
} from 'ramda'
import { humanizeString } from './humanizeString'

export const toCamelCase = (input: string | undefined): string => {
  if (typeof input !== 'string') {
    return '' // or throw new Error('Input must be a string');
  }

  return pipe(
    trim,
    split(' '),
    map(humanizeString),
    over(lensIndex(0), toLower),
    join(''),
    replace(/'+/g, ''),
  )(input)
}
